import React, { FC } from "react";
import { useLocation } from "react-router-dom";

import UserSidebar from "./Sidebar";

import { useSidebarStateStore } from "@store/sidebar";

interface SidebarContainer {}

const SidebarContainer: FC<SidebarContainer> = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = useSidebarStateStore();
  const location = useLocation();

  return (
    <UserSidebar
      collapsed={sidebarCollapsed}
      onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
      currentPath={location.pathname}
    />
  );
};

export default SidebarContainer;
